import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["quantity", "price"];

  connect() {
    this.min = this.quantityTarget.min || 1;
    this.max = this.quantityTarget.max || 5;
  }

  increment() {
    let currentValue = parseInt(this.quantityTarget.value, 10) || this.min;

    if (currentValue < this.max) {
      this.quantityTarget.value = currentValue + 1;
    }

    this.updateButtonStates();
    this.pricingCalculate();
    this.checkoutButtonUpdate();
  }

  decrement() {
    let currentValue = parseInt(this.quantityTarget.value, 10) || this.min;

    if (currentValue > this.min) {
      this.quantityTarget.value = currentValue - 1;
    }

    this.updateButtonStates();
    this.pricingCalculate();
    this.checkoutButtonUpdate();
  }

  updateButtonStates() {
    const currentValue = parseInt(this.quantityTarget.value, 10) || this.min;

    const decreaseButton = document.getElementById("eds-stepper-decrease-button");
    const increaseButton = document.getElementById("eds-stepper-increase-button");

    if (currentValue <= this.min) {
      decreaseButton.classList.add("eds-stepper-button--disabled");
    } else {
      decreaseButton.classList.remove("eds-stepper-button--disabled");
    }

    if (currentValue >= this.max) {
      increaseButton.classList.add("eds-stepper-button--disabled");
    } else {
      increaseButton.classList.remove("eds-stepper-button--disabled");
    }
  }

  pricingCalculate() {
    var baseValue = parseFloat(document.getElementById("base-price").innerText.replace("R$ ", "").replace(",", "."));
    this.priceTarget.innerText = `R$ ${(this.quantityTarget.value * baseValue).toFixed(2)}`.replace(".", ",");
  }

  checkoutButtonUpdate() {
    document.getElementById("checkout-event").href = document.getElementById("checkout-event").href.replace(/quantity=\d+/, `quantity=${this.quantityTarget.value}`);
  }
}
